import styled from "styled-components";

const MainImageContainer = styled.div`
    &:not(.loaded),
    &.loading {
        background-color: #efefef;
        > img {
            opacity: 0;
        }
    }
    @media (max-width: 767px) {
    }
    @media (max-width: 575px) {
        margin-bottom: 30px;
    }
`;

export default MainImageContainer;
